import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { atom, useRecoilState } from "recoil";
import { recoilPersist } from "recoil-persist";
import styled from "styled-components";
import { GetGradeString, getManagerGrade } from "../../AdminApi/commFunc";
import { isBeta } from "../../AdminConfig";
import useMy from "../../hooks/useMy";
import Flex from "../DefaultStyles/Flex";
import { BetaLogo } from "./SideNavigation";
import { useApi } from "../../hooks/useApi";
import { toast } from "react-toastify";
const { persistAtom } = recoilPersist();

interface SHeaderContainer {
  isFold?: boolean;
}

export const menuFoldState = atom({
  key: "menuFoldState",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export default function Header() {
  const [fold, setFold] = useRecoilState(menuFoldState);
  const { name, grade } = useMy();

  useEffect(() => {}, [grade]);

  const { response, error } = useApi({
    method: "get",
    url: `develop/status`,
  });

  useEffect(() => {
    if (error?.data) {
      toast.error(error?.data ?? "서버 상태를 가져오는 데에 실패하였습니다.");
    }
  }, [error]);

  // console.log(response?.data);
  // console.log(response?.data?.split("server Name")[1]);
  // console.log(response?.data?.split("server Name")[1].split("</table>")[0]);

  const splitedStr = response?.data
    ?.split("server Name")[1]
    .split("</table>")[0];
  const listSplitedStr = splitedStr?.split("</th>");

  const getStatusArrIdxByString = (findStr: string) => {
    return listSplitedStr?.findIndex((element: string) =>
      element?.includes(findStr)
    );
  };

  const checkEachServerError = (findStr: string) => {
    if (
      getStatusArrIdxByString(findStr) !== -1 &&
      listSplitedStr[getStatusArrIdxByString(findStr) + 1]?.split(">")[1]
    ) {
      return false;
    }
    return true;
  };

  // console.log(
  //   listSplitedStr[getStatusArrIdxByString("MainServer") + 1]?.split(">")[1]
  //     ? true
  //     : false
  // );

  return (
    <HeaderContainer isFold={fold}>
      <Flex gapSize={10} style={{ alignItems: "flex-start" }}>
        <FoldBtn onClick={() => setFold(!fold)}>
          <span className="material-symbols-outlined">
            {fold ? "menu" : "keyboard_double_arrow_left"}
          </span>
        </FoldBtn>

        <RefreshBtn onClick={() => window.location.reload()}>
          <span className="material-icons-outlined">refresh</span>
        </RefreshBtn>

        <>
          {isBeta && (
            <BetaLogo
              src={require("../../assets/header/ic_beta@2x.png")}
              alt="beta"
            />
          )}
        </>
      </Flex>

      <Flex>
        {response?.data && (
          <LightContainer>
            <Flex gapSize={4}>
              <LightLabel>서버</LightLabel>
              <Light
                // error={response?.data?.includes("/bin/www") ? false : true} // 서버
                error={checkEachServerError("MainServer")}
              />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>워커</LightLabel>
              <Light
                // error={response?.data?.includes("/nWorker.js") ? false : true} // 워커
                error={checkEachServerError("worker")}
              />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c1</LightLabel>
              <Lights
                // error={response?.data?.includes("/nWorker.js") ? false : true} // 체커 1
                error={checkEachServerError("checker1")}
              />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c2</LightLabel>
              <Lights error={checkEachServerError("checker2")} />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c3</LightLabel>
              <Lights error={checkEachServerError("checker3")} />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c4</LightLabel>
              <Lights error={checkEachServerError("checker4")} />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c5</LightLabel>
              <Lights error={checkEachServerError("checker5")} />
            </Flex>

            <Flex gapSize={4}>
              <LightLabel>c6</LightLabel>
              <Lights error={checkEachServerError("checker6")} />
            </Flex>
          </LightContainer>
        )}

        <Link to="my">
          <ManagerColumn>
            <ManagerLevel>
              {GetGradeString(grade) ?? getManagerGrade(String(grade))}
            </ManagerLevel>
            <ManagerName>{name}</ManagerName>
            <Lingling
              src={
                grade === 1
                  ? require("../../assets/lingling/ic-mylinkid-gold@2x.png")
                  : grade === 2
                  ? require("../../assets/lingling/ic-mylinkid-silver@2x.png")
                  : require("../../assets/lingling/ic-mylinkid-bronze@2x.png")
              }
              alt="lingling"
            />
          </ManagerColumn>
        </Link>
      </Flex>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header<SHeaderContainer>`
  position: fixed;
  top: 0;
  left: ${({ isFold }) => (isFold ? 0 : 240)}px;
  width: ${({ isFold }) => (isFold ? "100%" : "calc(100% - 240px)")};
  height: 64px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: ${({ theme }) => theme.color.white};
  padding: 0 40px 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 5;
  transition: left 0.2s ease;
`;

const RefreshBtn = styled.button`
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    width: 24px;
    color: #aaafb9;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

const ManagerColumn = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ManagerLevel = styled.span`
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #1e1e1e;
`;

const ManagerName = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: right;
  color: #1e1e1e;
  margin: 0 14px 0 6px;
`;

const Lingling = styled.img`
  width: 38px;
  aspect-ratio: 1/1;
`;

const FoldBtn = styled(RefreshBtn)`
  span {
    font-size: 24px;
  }
`;

const LightContainer = styled.div`
  padding: 9px 10px 9px 14px;
  border-radius: 19px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 24px;
`;

const LightLabel = styled.span`
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #858c97;
`;

const Light = styled.div<{ error: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ error }) => (error ? "#f42d16" : "#00c7c7")};
`;

const Lights = styled.div<{ error: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ error }) => (error ? "#f42d16" : "#00c7c7")};
`;
